import React, { useMemo } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '@/features/auth'

export const RequireAuth = () => {
  const auth = useAuth()
  const location = useLocation()

  // `sso` must stay a top level param: the SSO exchange in AuthProvider reads it
  // off window.location.search, so it would be lost inside an encoded redirect_to
  const redirectTo = useMemo(() => {
    const currentParams = new URLSearchParams(location.search)
    const sso = currentParams.get('sso')
    currentParams.delete('sso')

    const remaining = currentParams.toString()
    const loginParams = new URLSearchParams({
      redirect_to: location.pathname + (remaining ? `?${remaining}` : ''),
    })
    if (sso) loginParams.set('sso', sso)

    return loginParams.toString()
  }, [location.pathname, location.search])

  // Auth resolves asynchronously (token query, SSO exchange). Redirecting before it
  // settles would throw away a valid session that is still being established.
  if (!auth.initialized) {
    return <></>
  }

  if (!auth.isLoggedIn()) {
    return <Navigate to={`/auth/login?${redirectTo}`} replace />
  }

  return <Outlet />
}
